<script>
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    RangeSlider,
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem
  },

  data() {
    // ========== 静的変数 ==========
    const selectboxOptions = {
      vox: {
        voxDelayTime: BC.OPTIONAL_FEATURES.VOX_EXTERNAL_DEVICE.VOX.VOX_DELAY_TIME.map((value) => {
          const displayValue = Number.isInteger(value) ? value.toFixed(1) : String(value)
          return {
            label: `${displayValue}秒`,
            value: String(value),
          }
        }),
      },
    }

    return {
      radioSettings: null,
      selectboxOptions,
      // ========== リアクティブ変数 ==========
      form: {
        selectbox: {
          vox: {
            voxDelayTime: selectboxOptions.vox.voxDelayTime[0].value,
          },
        },
        toggle: {
          vox: {
            voxFunction: false,
            cancelByPtt: false,
            voxProceedTone: false,
            transmitInhibitWhileReceiving: false,
            earphoneMode: false,
          },
          externalSpeaker: {
            externalSpeakerFunction: false,
          },
        },
        range: {
          vox: {
            voxGainLevel: BC.OPTIONAL_FEATURES.VOX_EXTERNAL_DEVICE.VOX.VOX_GAIN_LEVEL.MIN,
          },
        },
      },
      setting: null
    }
  },

  computed: {
    BC() {
      return BC
    }
  },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    }
  },

  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.VOX_ExternalDevice

      console.log('============================')
      console.log(
        'before setting: ',
        JSON.parse(JSON.stringify(this.setting.OptionalFeatures.VOX_ExternalDevice)),
      )

      data.VOX.VOXFunction = this.form.toggle.vox.voxFunction
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.VOX.CancelByPTT = this.form.toggle.vox.cancelByPtt
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.VOX.VOXProceedTone = this.form.toggle.vox.voxProceedTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.VOX.TransmitInhibitWhileReceiving = this.form.toggle.vox.transmitInhibitWhileReceiving
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.VOX.VOXGainLevel = this.form.range.vox.voxGainLevel
      data.VOX.VOXDelayTime = this.form.selectbox.vox.voxDelayTime
      data.VOX.EarphoneMode = this.form.toggle.vox.earphoneMode
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.ExternalSpeaker.ExternalSpeakerFunction = this.form.toggle.externalSpeaker
        .externalSpeakerFunction
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      console.log(
        'after setting: ',
        JSON.parse(JSON.stringify(this.setting.OptionalFeatures.VOX_ExternalDevice)),
      )
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.VOX_ExternalDevice

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      this.form.toggle.vox.voxFunction = data.VOX.VOXFunction === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.vox.cancelByPtt = data.VOX.CancelByPTT === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.vox.voxProceedTone = data.VOX.VOXProceedTone === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.vox.transmitInhibitWhileReceiving =
        data.VOX.TransmitInhibitWhileReceiving === BC.COMMON.TOGGLE.ENABLE
      this.form.range.vox.voxGainLevel = data.VOX.VOXGainLevel
      this.form.selectbox.vox.voxDelayTime = data.VOX.VOXDelayTime
      this.form.toggle.vox.earphoneMode = data.VOX.EarphoneMode === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.externalSpeaker.externalSpeakerFunction =
        data.ExternalSpeaker.ExternalSpeakerFunction === BC.COMMON.TOGGLE.ENABLE

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleSelect(value) {
      this.form.selectbox.vox.voxDelayTime = Number(value)
    }
  }
}
</script>

<template>
  <div>
    <SettingGroup title="VOX">
      <SettingItem label="VOX">
        <ToggleSwitch v-model="form.toggle.vox.voxFunction" :disable="false" />
      </SettingItem>
      <SettingItem label="キャンセル動作">
        <ToggleSwitch v-model="form.toggle.vox.cancelByPtt" :disable="false" />
      </SettingItem>
      <SettingItem label="VOX通話開始トーン">
        <ToggleSwitch v-model="form.toggle.vox.voxProceedTone" :disable="false" />
      </SettingItem>
      <SettingItem label="受信中の送信禁止">
        <ToggleSwitch
          v-model="form.toggle.vox.transmitInhibitWhileReceiving"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="マイク感度">
        <RangeSlider
          :inputValue="form.range.vox.voxGainLevel"
          @update:inputValue="form.range.vox.voxGainLevel = $event"
          :disable="false"
          :minLimit="BC.OPTIONAL_FEATURES.VOX_EXTERNAL_DEVICE.VOX.VOX_GAIN_LEVEL.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.VOX_EXTERNAL_DEVICE.VOX.VOX_GAIN_LEVEL.MAX"
        />
      </SettingItem>
      <SettingItem label="終話遅延時間">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.vox.voxDelayTime"
          :defaultValue="String(form.selectbox.vox.voxDelayTime)"
          @update="handleSelect"
        />
      </SettingItem>
      <SettingItem label="イヤホン・モード">
        <ToggleSwitch v-model="form.toggle.vox.earphoneMode" :disable="false" />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="外部スピーカー">
      <SettingItem label="外部スピーカーの設定">
        <ToggleSwitch
          v-model="form.toggle.externalSpeaker.externalSpeakerFunction"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>
